module.exports = __webpack_public_path__ + "static/media/instagram.2d8c5cde.png";